// extracted by mini-css-extract-plugin
module.exports = {"BackButton":"RecordDetailContainer_BackButton__2ZEpm"};